import { compose, withProps, withState, lifecycle } from 'recompose'

const CommentInputContianer = compose(
  withState('element', 'innerRef'),
  withProps(({ element }) => ({
    height: (element && element.scrollHeight) || 60
  })),
  lifecycle({
    componentDidUpdate(prevProps) {
      // Ensure textarea is focused if autoFocus becomes true after mount
      if (!prevProps.autoFocus && this.props.autoFocus)
        this.props.element.focus()
    }
  })
)

export default CommentInputContianer
